import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, timeout } from 'rxjs/operators';
import { ProblemCategoryDTO } from '../masterdata/models/problemCategory';
import { environment } from "../../environments/environment";
import { BBResponseContainer } from '../common-services/response-container';


@Injectable()
export class  ProblemCategoryService { 

  readonly PROBLEMCATEGORYMDMSERVICE = 'admin/mdm/problemcategory';

  constructor(private http: HttpClient) {
  }

  getProblemCategory(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.PROBLEMCATEGORYMDMSERVICE;
        return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    addProblemCategory(problem: ProblemCategoryDTO) {
        let url: string = environment.BB_MDMSERVICE_URL + this.PROBLEMCATEGORYMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, problem).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        }));
    }

    updateProblemCategory(problem: ProblemCategoryDTO) {
        let url: string = environment.BB_MDMSERVICE_URL + this.PROBLEMCATEGORYMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, problem).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    getProblemsList(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.PROBLEMCATEGORYMDMSERVICE + '/all';
        return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    getProblemsListWithFilter(labId: string, active: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.PROBLEMCATEGORYMDMSERVICE;
        let requestParam = new HttpParams().set('labId', labId).set('active', active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }
}